import React from "react";
import { Helmet } from "react-helmet-async";
import { SidebarDemo } from "./../Sidebar/SidebarDemo";

export default function Layout() {
  return (
    <>
      <Helmet>
        <title>Dashboard | Halper AI</title>
        <meta name="description" content="Manage your business appointments, payments, and client chat from your Halper AI dashboard." />
      </Helmet>
      <SidebarDemo />
    </>
  );
}